import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SaveAltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"save_alt"}/>
}
